import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

// Access Hub pages
import AccessHubOverview from 'components/pages/Applications/AccessHub'
import AccessHubSpecific from 'components/pages/Applications/AccessHub/Specific'

import { useIsAuthenticated } from 'redux/hooks/SignedInAccount'

import AuthRoute from './AuthRoute'

const Routes = () => {
  const isAuthenticated = useIsAuthenticated()

  return (
    <Switch>
      {/* Access Hub */}
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={AccessHubOverview}
        path={'/access-hub'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={AccessHubSpecific}
        path={'/access-hub/:id/connection'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={AccessHubSpecific}
        path={'/access-hub/:id/dataset'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={AccessHubSpecific}
        path={'/access-hub/:id/dataset/new'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={AccessHubSpecific}
        path={'/access-hub/:id/connection/new'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={AccessHubSpecific}
        path={'/access-hub/:id/dataset/edit/:tableId'}
        exact
      />
      <Route path={'/access-hub/*'}>
        <Redirect to="/access-hub" />
      </Route>
    </Switch>
  )
}

export default Routes
